import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MenuItem } from '@awp/models';

export const MENU_TOKEN = new InjectionToken<MenuService>('Menu Items');

export interface MenuService {
  readonly values: Observable<Array<MenuItem>>;
}
